import { B } from "../../design/tokens";
import Reveal from "../shared/Reveal";
import Tag from "../shared/Tag";

export default function ProcessSection() {
  const steps = [
    { n: "01", title: "Initial Inquiry",      desc: "Submit via form, email, or phone. We respond within 24 hours with a free initial assessment of your property needs." },
    { n: "02", title: "Scope & Proposal",      desc: "We confirm the scope of work and send a detailed engagement letter with a transparent fee schedule upfront." },
    { n: "03", title: "Service Execution",     desc: "Our licensed team handles all documentation, government agency coordination, and compliance requirements end-to-end." },
    { n: "04", title: "Delivery & Compliance", desc: "We deliver all outputs — titles, reports, plans, or clearances — with a full project summary and official confirmation." },
  ];
  return (
    <section style={{ background: `linear-gradient(160deg, ${B.navy} 0%, ${B.navyMid} 50%, ${B.royal} 100%)`, padding: "120px 0", position: "relative", overflow: "hidden" }}>
      <svg style={{ position: "absolute", inset: 0, width: "100%", height: "100%", pointerEvents: "none", opacity: 0.04 }}>
        <defs><pattern id="pg" width="56" height="56" patternUnits="userSpaceOnUse"><path d="M 56 0 L 0 0 0 56" fill="none" stroke={B.white} strokeWidth="0.5" /></pattern></defs>
        <rect width="100%" height="100%" fill="url(#pg)" />
      </svg>
      <div style={{ maxWidth: 1280, margin: "0 auto", padding: "0 32px", position: "relative", zIndex: 2 }}>
        <Reveal style={{ textAlign: "center", marginBottom: 72 }}>
          <Tag text="How We Work" onDark />
          <h2 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "clamp(32px, 4vw, 52px)", fontWeight: 700, color: B.white, lineHeight: 1.1, letterSpacing: -0.5, marginBottom: 14 }}>
            A Simple, <em style={{ color: B.mist }}>Transparent Process</em>
          </h2>
          <p style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: 16, color: B.faint, lineHeight: 1.8, maxWidth: 480, margin: "0 auto" }}>
            From your first inquiry to final delivery — every step designed for clarity, speed, and your peace of mind.
          </p>
        </Reveal>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 0 }} className="process-grid">
          {steps.map((st, i) => (
            <Reveal key={i} delay={0.1 * i}>
              <div style={{ padding: "40px 36px", borderRight: i < 3 ? `1px solid ${B.hairline}` : "none", position: "relative" }}>
                {i < 3 && <div style={{ position: "absolute", top: 52, right: -14, width: 28, height: 28, background: `${B.azure}22`, border: `1px solid ${B.azure}44`, display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1, fontFamily: "'Space Grotesk', sans-serif", fontSize: 14, color: B.mist }} className="process-arrow">›</div>}
                <div style={{ width: 52, height: 52, marginBottom: 24, background: `linear-gradient(135deg, ${B.azure}22, ${B.sky}11)`, border: `1.5px solid ${B.azure}44`, display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <span style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: 18, fontWeight: 700, color: B.mist }}>{st.n}</span>
                </div>
                <h3 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 22, fontWeight: 700, color: B.white, marginBottom: 12, lineHeight: 1.25 }}>{st.title}</h3>
                <p style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: 14, color: B.faint, lineHeight: 1.8 }}>{st.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
